import {
  AppBar,
  Avatar,
  Box,
  Button,
  ButtonGroup,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  Toolbar,
  Typography,
} from '@mui/material'
import { useAuth } from '../../providers'
import { Link, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'

export default function NavBar() {
  const { user, isLoading, logout } = useAuth()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const notShowedPages = ['/login', '/no-subscription']
  const location = useLocation()

  useEffect(() => {
    if (!user) {
      setAnchorEl(null)
    }
  }, [user])

  if (notShowedPages.includes(location.pathname)) {
    return null
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setAnchorEl(null)
    logout()
  }

  return (
    <AppBar position="sticky">
      <Toolbar variant="dense">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            width: '100%',
            maxWidth: '1200px',
            margin: '0 auto',
            gap: 2,
          }}
        >
          <Box />
          {isLoading ? (
            <Skeleton variant="text" width={100} height={40} />
          ) : (
            <ButtonGroup variant="text" color="inherit">
              {user && (
                <>
                  <Button component="a" href="/" color="inherit">
                    UYAP
                  </Button>
                  <Button component={Link} to="/dashboard">
                    Servisler
                  </Button>
                </>
              )}
              {user ? (
                <>
                  <IconButton
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={anchorEl ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={anchorEl ? 'true' : undefined}
                  >
                    <Avatar sx={{ width: 32, height: 32 }}>
                      {user.email.charAt(0)}
                    </Avatar>
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl) && Boolean(user)}
                    onClose={handleMenuClose}
                    anchorEl={anchorEl}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem>
                      <Typography>{user.email}</Typography>
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>Çıkış Yap</MenuItem>
                  </Menu>
                </>
              ) : (
                <Button component={Link} to="/login">
                  Giriş Yap
                </Button>
              )}
            </ButtonGroup>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  )
}
